function initialState() {
  return {
    accountFlags: null,
    definitions: null,
  }
}

let state = initialState()

export { initialState, state }
